export class RoutesInvoker {
  // Account
  static login() {
    return "/account/login";
  }

  static logout() {
    return "/account/logout";
  }

  static forgottenPassword() {
    return "/account/forgotten-password";
  }

  static requestForgottenPassword() {
    return "/account/request-forgotten-password";
  }

  static completeRegistration() {
    return "/account/complete-registration";
  }

  static releaseNotes = "/whats-new";

  static enquiry = (enquiryId: number) => {
    return `/enquiries/${enquiryId}`;
  }

  static enquiryItinerary = (enquiryId: number, quoteId?: number) => {
    return quoteId
      ? `/enquiries/${enquiryId}/itinerary/${quoteId}`
      : `/enquiries/${enquiryId}/itinerary`;
  }

  static enquiryItineraryBuilder(enquiryId: number) {
    return "/enquiries/" + enquiryId + "/itinerary-builder";
  }

  static enquiryPayment(enquiryId: number) {
    return "/enquiries/" + enquiryId + "/payment";
  }

  static enquirySettings(enquiryId: number) {
    return "/enquiries/" + enquiryId + "/settings";
  }

  static enquiryTripDetails(enquiryId: number) {
    return "/enquiries/" + enquiryId + "/trip-details";
  }

  // Admin
  static adminEnquiryDashboard = "/admin/enquiries";

  // Enquiries
  static adminTriage = "/admin/enquiries/triage";
  static adminAllPlanningEnquiries = "/admin/enquiries/planning";
  static adminAllConfirmedEnquiries = "/admin/enquiries/confirmed";
  static adminAllUnconfirmedEnquiries = "/admin/enquiries/unconfirmed";
  static adminAllTravellingEnquiries = "/admin/enquiries/travelling";
  static adminAllCompleteEnquiries = "/admin/enquiries/complete";
  static adminAllSnoozedEnquiries = "/admin/enquiries/snoozed";
  static adminAllEnquiries = "/admin/enquiries/all";

  // Enquiries per LTO
  static adminEnquiriesFocus = (ltoId: number) => `/admin/ltos/${ltoId}/focus`;
  static adminEnquiriesPlanning = (ltoId: number) => `/admin/ltos/${ltoId}/planning`;
  static adminEnquiriesBooked = (ltoId: number) => `/admin/ltos/${ltoId}/booked`;
  static adminEnquiriesTravelling = (ltoId: number) => `/admin/ltos/${ltoId}/travelling`;
  static adminEnquiriesComplete = (ltoId: number) => `/admin/ltos/${ltoId}/complete`;
  static adminEnquiriesAll = (ltoId: number) => `/admin/ltos/${ltoId}/all`;

  // LTOs
  static adminLtos = "/admin/ltos";
  static adminAllLtos = "/admin/ltos";
  static adminBookingStatistics = "/admin/ltos/booking-statistics";

  static adminLtoIndex(ltoId: number) {
    return "/admin/ltos/" + ltoId;
  }

  static adminLtoProfile(ltoId: number) {
    return "/admin/ltos/" + ltoId + "/profile";
  }

  static adminLtoUsers(ltoId: number) {
    return "/admin/ltos/" + ltoId + "/users";
  }

  static adminLtoSettings(ltoId: number) {
    return "/admin/ltos/" + ltoId + "/settings";
  }

  static adminLtoSnippets(ltoId: number) {
    return "/admin/ltos/" + ltoId + "/snippets";
  }

  static adminLtoEnquiries = (ltoId: number) => RoutesInvoker.adminLtoIndex(ltoId);

  static adminUserProfile(userId: number) {
    return "/admin/user/" + userId + "/profile";
  }

  static adminLtoSampleItineraries(ltoId: number) {
    return "/admin/ltos/" + ltoId + "/sample-itineraries";
  }

  static adminLtoComponentManagement(ltoId: number) {
    return "/admin/ltos/" + ltoId + "/component-management";
  }

  static adminLtoReviews(ltoId: number) {
    return "/admin/ltos/" + ltoId + "/reviews";
  }

  static adminEditLtoSampleItinerary(ltoId: number, itinerarySlug: string) {
    return "/admin/ltos/" + ltoId + "/sample-itineraries/" + itinerarySlug + "/edit";
  }

  // Locations
  static adminLocations() {
    return "/admin/locations";
  }

  static adminEditLocation(locationSlug: string) {
    return "/admin/locations/" + locationSlug;
  }

  static adminThemes = "/admin/themes";
  static adminThemeEdit = (id: number) => `/admin/themes/${id}/edit`;
  static adminThemeCreate = `/admin/themes/create`;
  static adminContent = "/admin/content";
  static adminContentEdit = (id: number) => `/admin/content/${id}/edit`;
  static adminReviews = "/admin/reviews";
  static adminAddReview = "/admin/reviews/add";
  static adminEditReview = (id: number) => `/admin/reviews/${id}/edit`;
  static adminPayments = "/admin/payments";

  static adminExchangeRates() {
    return "/admin/exchange-rates";
  }

  static adminComponentManagement() {
    return "/admin/component-management";
  }

  public static adminSnippetsManagement() {
    return "/admin/snippets-management";
  }

  static adminSettings = "/admin/settings";
  static adminSettingsTeam = "/admin/settings/team-profiles";
  static adminSettingsExchangeRates = "/admin/settings/exchange-rates";

  // Lto
  static ltoIndex() {
    return "/lto";
  }

  static ltoDashboard() {
    return "/lto";
  }

  static ltoProfile() {
    return "/lto/profile";
  }

  static ltoReviews() {
    return "/lto/reviews";
  }

  static ltoComponentManagement() {
    return "/lto/component-management";
  }

  static ltoEnquiries() {
    return "/lto";
  }

  static ltoSampleItineraries() {
    return "/lto/sample-itineraries";
  }

  static ltoEditSampleItinerary(itinerarySlug: string) {
    return "/lto/sample-itineraries/" + itinerarySlug + "/edit";
  }

  public static ltoEnquiryBookingTerms(enquiryId: number) {
    return "/enquiries/" + enquiryId + "/booking-terms";
  }

  static ltoEnquiriesFocus = "/lto/focus";
  static ltoEnquiriesPlanning = "/lto/planning";
  static ltoEnquiriesBooked = "/lto/booked";
  static ltoEnquiriesTravelling = "/lto/travelling";
  static ltoEnquiriesComplete = "/lto/complete";
  static ltoEnquiriesAll = "/lto/all";


}
